import FullWidthLayout from "@/layouts/FullWidthLayout";
import ThirdPartyServicesTable from "kinnect-front/ThirdPartyServices/ThirdPartyServicesTable";
import { FetchesData, Pageable } from "kinnect-mixins";
import { KTextField } from "kinnect-general";
import { ThirdPartyService } from "kinnect-models";
import { VCard, VSheet } from "vuetify/lib";

export default {
	name: "ThirdPartyServicesPage",

	metaInfo: { title: "3rd Party Services" },

	mixins: [
		FetchesData,
		Pageable
	],

	data: () => ( {
		thirdPartyServices: [],
		search: ""
	} ),

	computed: {
		numItems() {
			return this.thirdPartyServices.length;
		},

		toolbarActions() {
			if ( this.$can( "add_third_party_services" ) ) {
				return {
					icon: "add_circle",
					text: "Add Service",
					to: { name: "thirdPartyServiceAdd" },
					tooltip: "Add 3rd party service"
				};
			}
		}
	},

	watch: {
		numItems( numItems ) {
			this.$store.dispatch( "breadcrumbs/setDetails", `${numItems} services` );
		}
	},

	methods: {
		async fetchThirdPartyServices() {
			this.thirdPartyServices = await ThirdPartyService.get();
		},

		async fetch() {
			await this.fetchThirdPartyServices();
		}
	},

	render() {
		return <FullWidthLayout>
			<VCard>
				<VSheet class="pa-3" color="primary" tile>
					<KTextField
						clearable
						dark
						flat
						hideDetails
						label="Search"
						prependInnerIcon="search"
						soloInverted
						vModel={this.search}
					></KTextField>
				</VSheet>

				<ThirdPartyServicesTable
					items={this.thirdPartyServices}
					loading={this.$wait.is( "get third party services" )}
					search={this.search}
				></ThirdPartyServicesTable>
			</VCard>
		</FullWidthLayout>;
	}
};
